module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-horizontal-345bf2ed6dbf4ef71807b7703196b2cd.svg";